import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface TimeOfDayDTO {
  hour: number;
  minute: number;
}

export class TimeOfDay {
  readonly isTimeOfDayTimeOfDay: boolean = true;

  readonly hour: number;
  readonly minute: number;

  static readonly constraints = {
    "hour": {
      "minValue": 0,
      "maxValue": 23,
    },
    "minute": {
      "minValue": 0,
      "maxValue": 59,
    }
  }

  constructor(
  hour: number, 
  minute: number
  ) {
    TimeOfDay.validateHour(hour);
    this.hour = hour;
    TimeOfDay.validateMinute(minute);
    this.minute = minute;
  }

  static fromDTO(dto: TimeOfDayDTO): TimeOfDay {
    const hour = getInt32(dto, "hour", InvalidTimeOfDayHourError);
    const minute = getInt32(dto, "minute", InvalidTimeOfDayMinuteError);
    return new TimeOfDay(
      hour,
      minute
    );
  }

  toDTO(): TimeOfDayDTO {
    const dto: TimeOfDayDTO = {
        hour: this.hour,
        minute: this.minute
    };
    return dto;
  }
  private static validateHour = (hour: number): void => {
    if(hour < 0) {
      throw new InvalidTimeOfDayHourMinValueError(
        0,
        `Attribute hour has value ${hour}. Min value is 0.`
      );
    }
    if(hour > 23) {
      throw new InvalidTimeOfDayHourMaxValueError(
        23,
        `Attribute hour has value ${hour}. Max value is 23.`
      );
    }
  }
  private static validateMinute = (minute: number): void => {
    if(minute < 0) {
      throw new InvalidTimeOfDayMinuteMinValueError(
        0,
        `Attribute minute has value ${minute}. Min value is 0.`
      );
    }
    if(minute > 59) {
      throw new InvalidTimeOfDayMinuteMaxValueError(
        59,
        `Attribute minute has value ${minute}. Max value is 59.`
      );
    }
  }
  
}

TimeOfDay.prototype.toString = function toString(): string {
  return `TimeOfDay(hour='${this.hour}',minute='${this.minute}')`;
};

export class InvalidTimeOfDayError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTimeOfDayError";
  }
}
export class InvalidTimeOfDayHourError extends InvalidTimeOfDayError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTimeOfDayHourError";
  }
}

export class InvalidTimeOfDayHourMaxValueError extends InvalidTimeOfDayHourError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTimeOfDayHourMaxValueError";
  }
}

export class InvalidTimeOfDayHourMinValueError extends InvalidTimeOfDayHourError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTimeOfDayHourMinValueError";
  }
}

export class InvalidTimeOfDayMinuteError extends InvalidTimeOfDayError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTimeOfDayMinuteError";
  }
}

export class InvalidTimeOfDayMinuteMaxValueError extends InvalidTimeOfDayMinuteError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTimeOfDayMinuteMaxValueError";
  }
}

export class InvalidTimeOfDayMinuteMinValueError extends InvalidTimeOfDayMinuteError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTimeOfDayMinuteMinValueError";
  }
}
